<template>
    <div>
        <v-expand-transition>
            <v-row v-if="estadoComp == true">
                <v-col cols="12" class="d-flex justify-end">
                    <ButtonComp @click="changesParent()" text-button="Ver evaluación" icon-but="fas fa-book-open"
                        normal-button />
                </v-col>
                <v-col cols="12">
                    <v-sheet color="transparent" v-if="skeletonLoadTable">
                        <v-skeleton-loader type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
                    </v-sheet>
                    <ComundataTablecomp v-else :headers="headers" :items="dataListPreguntas" :search="search"
                        :sort-by="['nombre_template']" :sort-desc="[false]" whitSearch>
                        <template v-slot>
                            <h3> <v-icon left small>fa-check </v-icon> {{ formTitle }}</h3>
                        </template>
                        <template v-slot:titulo="{ item }">
                            <span>{{ item.titulo | quitarTag }}</span>
                        </template>
                        <template v-slot:pregunta="{ item }">
                            <span>{{ item.pregunta | quitarTag }}</span>
                        </template>
                        <template v-slot:action_pregunta="{ item }">
                            <v-switch v-model="preguntaEval" color="primary" :value="item.id"
                                @click="evetPregunta(item)"></v-switch>
                        </template>
                        <template v-slot:action_editar="{ item }">
                            <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)"
                                tooltip-text="Editar pregunta" editButton />

                        </template>
                        <template v-slot:action_borrar="{ item }">
                            <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteItem(item.id)"
                                tooltip-text="Eliminar pregunta" delete-button />
                        </template>
                    </ComundataTablecomp>
                </v-col>
            </v-row>
        </v-expand-transition>
        <v-expand-transition>
            <component :is="compName" :estadoComp="estadoModalConfig" :parametros="parametroConfig" @close="closeModal">
            </component>
        </v-expand-transition>
        <confirm @aceptar="deleted" @cancelar="cancelar" titleWindow="Eliminar pregunta" :title="confirm.title"
            :active="confirm.active" />

    </div>
</template>

<script>

import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import ButtonComp from "../../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from "../../../../../components/ComponentsEst/ComundataTablecomp.vue";


import PreguntaFormComp from './preguntaFormComp.vue'
export default {
    name: 'PreguntaEval',
    components: {
        PreguntaFormComp,
        ButtonComp,
        ComundataTablecomp
    },

    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
    },

    data: () => ({
        skeletonLoadTable: false,
        rutaservidor: API_URL,
        paramComponente: { "id_modulo": 8, 'id_submodulo': 94 },
        datoLogin: sessionStorage,

        dataPreguntas: [],

        confirm: {
            id: 0,
            title: "",
            active: false,
        },
        search: '',
        dataListPreguntas: [],
        filter: {},
        Plantillas: [],
        headers: [
            { text: 'TEMA', value: 'nombre_tema', class: 'header_datatable' },
            { text: 'TITULO', value: 'titulo', class: 'header_datatable' },
            { text: 'TIPO DE RESPUESTA', value: 'tipo_pregunta', class: 'header_datatable' },
            { text: 'DIFICULTAD', value: 'dificultad', class: 'header_datatable' },
            { text: 'PREGUNTA', value: 'pregunta', class: 'header_datatable' },
            { text: 'SELECCIONE', value: 'action_pregunta', class: 'header_datatable' },
            { text: 'EDITAR', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable', width: '50' },
            { text: 'ELIMINAR', value: 'action_borrar', sortable: false, align: 'center', class: 'header_datatable', width: '50' }
        ],

        formTitle: 'Banco de preguntas de evaluación:',
        compName: null,
        estadoModalConfig: true,
        parametroConfig: [],
        preguntaEval: [],
    }),
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento',
        }),
        ...mapState({
            listaPreguntasArray: state => state.gestEvaluacion.listaPreguntasArray
        }),
    },
    filters: {
        quitarTag: function (value) {
            if (!value) return '';
            // Eliminar etiquetas HTML
            value = value.replace(/<\/?[^>]+>/ig, " ");
            // Convertir entidades HTML a caracteres normales
            var parser = new DOMParser();
            var dom = parser.parseFromString(
                '<!doctype html><body>' + value,
                'text/html'
            );
            return dom.body.textContent;
        },
    },
    watch: {
        estadoComp(value) {
            if (value) {
                this.loadMain()
            } else {
                this.limpiarForm()
            }
        },
    },
    mounted() {
        this.loadMain()
    },
    created() {

        this.actualizarParamentro()
    },
    methods: {
        ...mapActions({
            parametroComponente: "login/parametroComponente"
        }),
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            setlistaPreguntas: "gestEvaluacion/setlistaPreguntas",
        }),
        /** 
         ____________________________________
        |  MÉTODO USAR PERMISOS DE PERFIL  */
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        /** 
         __________________________
        |  MÉTODO CARGA INICIAL  */
        async loadMain() {

            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_docente: this.parametros.items.id_docente,
                id_programacion: this.parametros.items.id_programacion
            }

            this.getPregunta(this.filter)

            if (this.listaPreguntasArray.length == 0) {
                this.preguntaEval = [];
            } else {
                let idData = []
                this.listaPreguntasArray.forEach(element => {
                    idData.push(element.id)
                });
                this.preguntaEval = idData;

            }
            // this.getPreguntaEval()
            // this.getTemplate()
        },
        changesParent() {
            this.$emit('close')
        },
        /** 
         _____________________________
        |  MÉTODO OBTENER PREGUNTA  */
        async getPregunta(filter) {
            this.skeletonLoadTable = true;
            try {
                let response = await axios.post(`/evaluacion/bancoPregunta/view/`, { filter })

                if (response.data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                } else {

                    const bancoPreguntas = response.data.map(item => {
                        return { ...item, id_valor: this.parametros.items.id_valor, }
                    })
                    this.dataListPreguntas = bancoPreguntas

                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            } finally {
                this.skeletonLoadTable = false;
            }

        },
        /** 
         _________________________________
        |  MÉTODO PREGUNTRA EVALUACION  */
        async getPreguntaEval() {
            try {
                let response = await axios.get(`/evaluacion/pregunta/getIdPregunta/${this.parametros.items.id}`,)
                let data = response.data
                if (data.length == 0) {
                    // this.setEnviarMens({tipo:"W", mensaje: `No se encontrarón registros`, tiempo:null})    
                } else {
                    this.preguntaEval = []
                    data.forEach(element => {
                        this.preguntaEval.push(element.id_banco_pregunta)
                    });
                }
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /** 
         _____________________________
        |  MÉTODO OBTENER TEMPLATE  */
        async getTemplate() {

            try {

                let response = await axios.post(`/administrativo/contenido/getTemplate/`, { filtro: { id_colegio: sessionStorage.id_colegio, estado_template: 1, tipo: 2 } })
                let objectNew = JSON.parse(JSON.stringify(response.data))

                objectNew.unshift({
                    "id": -1,
                    "nombre_template": "Ninguno",
                })

                this.Plantillas = objectNew
                this.prueba = response.data
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /** 
         ____________________________
        |  MÉTODO EVENTO PREGUNTA  */
        // eslint-disable-next-line no-unused-vars
        async evetPregunta(item) {
            const arrayP = this.dataListPreguntas.filter(obj => this.preguntaEval.includes(obj.id));
            this.setlistaPreguntas(arrayP);

            // // Actualizar el estado del switch en el objeto correspondiente
            // const itemToUpdate = this.dataListPreguntas.find(x => x.id === item.id);
            // if (itemToUpdate) {
            //     itemToUpdate.isActive = !itemToUpdate.isActive;
            // }

            // // Reordenar los items para mover los activos al inicio
            // this.dataListPreguntas.sort((a, b) => {
            //     if (a.isActive && !b.isActive) {
            //         return -1;
            //     }
            //     if (!a.isActive && b.isActive) {
            //         return 1;
            //     }
            //     return 0;
            // });
        },
        ///////////////////////////////////////////////////
        //-- Componente de  Configuracion de colegio  -----
        ///////////////////////////////////////////////////
        addItem() {
            //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
            this.parametroConfig = { evento: "add", items: this.parametros.items }
            this.compName = "PreguntaFormComp"
            this.estadoModalConfig = true
        },
        /** 
         _________________________
        |  MÉTODO EDITAR ITEMS  */
        editItem(items) {
            // this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})       
            this.parametroConfig = { evento: "edit", items }
            this.estadoComp = false
            this.compName = "PreguntaFormComp"
            this.estadoModalConfig = true
        },
        /** 
         ______________________
        |  MÉTODO VER ITEMS  */
        viewItem(item) {
            // this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})
            this.parametroConfig = { evento: "view", item }
            this.compName = "ConductualFormComp"
            this.estadoModalConfig = true
        },
        /** 
         _________________________
        |  MÉTODO CERRAR MODAL  */
        closeModal() {
            this.estadoModalConfig = false
            this.estadoComp = true

            this.loadMain()
        },
        /** 
         ____________________________
        |  MÉTODO ELIMINAR ITEMS  */
        async deleteItem(id) {
            this.confirm.active = true;
            this.confirm.title = "¿Está seguro que desea eliminar este registro?";
            this.confirm.id = id;
            // console.log("confimr:", this.confirm);
        },
        /** 
         _____________________
        |  MÉTODO ELIMINAR  */
        async deleted() {
            try {

                await axios.delete("/evaluacion/bancoPregunta/" + this.confirm.id).then((resp) => {

                    if (resp.data.messageT == "S") {
                        this.clear_confirm()
                        this.getPregunta(this.filter)

                    }

                    this.setEnviarMens({
                        tipo: resp.data.messageT,
                        mensaje: resp.data.message,
                        tiempo: null,
                    });

                });
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        /** 
         ____________________________
        |  MÉTODO CANCELAR ACTION  */
        cancelar() {
            this.clear_confirm();
        },
        /** 
         ____________________________
        |  MÉTODO CONFIRMAR ACTION */
        clear_confirm() {
            this.confirm.id = 0;
            this.confirm.title = "";
            this.confirm.active = false;
        },
        /** 
         ____________________
        |  MÉTODO LIMPIAR  */
        limpiarForm() {
        },
    },

}
</script>

<style>
.custom-bottom-sheet .v-sheet {
    border-radius: 20px;
}

/* .v-skeleton-loader {
    border-radius: 0px;
}

.v-skeleton-loader__table-row {
    background: #fff;
}

.v-skeleton-loader__divider {
    background: #e4e4e4 !important;
} */
</style>